import { Divider, Modal, Title, rem } from "@mantine/core";
import { fetcher } from "../../../services/fetcher";
import { SalesLeads_Api } from "../../../api/endpoints";
import { successNotifications } from "../../../utils/handleNotifications";
import LeadForm from "./LeadForm";
import { buildQuotationPayload, unwrapLead } from "../utils/leadFormUtils";

const getResourceId = (response) =>
  response?.id ?? response?.data?.id ?? unwrapLead(response)?.id;

const LeadFormModal = ({ opened, onClose, onCreated }) => {
  const finish = async () => {
    if (typeof onCreated === "function") await onCreated();
    onClose();
  };

  const handleSubmit = async (payload) => {
    await fetcher(SalesLeads_Api, "POST", payload);
    successNotifications("Success! Lead created");
    await finish();
  };

  const handleCreateAndQuotation = async (payload, activityId) => {
    const leadRes = await fetcher(SalesLeads_Api, "POST", payload);
    const leadId = getResourceId(leadRes);
    const quoteRes = await fetcher(
      "crm/quotations/",
      "POST",
      buildQuotationPayload(leadId, payload, activityId)
    );
    const quotationId = getResourceId(quoteRes);
    if (!quotationId) throw new Error("Quotation was not created.");
    await fetcher(`crm/quotations/${quotationId}/send_email/`, "POST", {});
    successNotifications("Lead created and quotation sent");
    await finish();
  };

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={
        <Title
          order={2}
          fz={24}
          fw={500}
          ff="Montserrat, sans-serif"
          c="#092C4C"
          ta="center"
          style={{ flex: 1, fontStyle: "normal", width: "100%" }}
          lineClamp={2}
        >
          New Lead
        </Title>
      }
      size="lg"
      styles={{
        header: { justifyContent: "center" },
        title: { width: "100%" },
      }}
    >
      {opened ? (
        <>
          <Divider
            size={2}
            styles={{
              root: {
                border: "none",
                height: 2,
                background: "linear-gradient(270deg, #0053A8 0%, #033F7C 100%)",
                borderRadius: 8,
                opacity: 0.15,
                marginLeft: rem(12),
                marginRight: rem(12),
              },
            }}
          />
          <LeadForm
            createMode
            onSubmit={handleSubmit}
            onCreateAndQuotation={(payload) =>
              handleCreateAndQuotation(payload, payload.cover_id)
            }
            showCancel
            onCancel={onClose}
          />
        </>
      ) : null}
    </Modal>
  );
};

export default LeadFormModal;
